module.exports = __webpack_public_path__ + "media/shippy/mail-90855437.svg";